class PlusHero extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.initPlusHero();
        this.initPLusOffer();
        this.setupRichText();
    }
    initPlusHero() {
        let tlBg = gsap.timeline({
            scrollTrigger: {
                trigger: this,
                start: 'top top',
                end: 'bottom bottom',
                scrub: true,
            }
        });
        // tlBg.to(this.querySelector('.plus-hero-bg-inner'), {backgroundColor: 'transparent', ease: 'none'})
        this.modifyTitle()
        setTimeout(() => {
            this.setup()
        }, 100);
    }
    modifyTitle() {
        let title = this.querySelector('.plus-hero-title .txt');
        let modifiedTitle = title.innerHTML.replace(/_(.*?)_/g, '<span class="txt-highlight">$1 </span><br>');
        title.innerHTML = modifiedTitle;
        setTimeout(() => {
            title.classList.add('show')
        }, 100);
    }
    setup() {
        this.tl = gsap.timeline({
            delay: .5,
            onStart: () => {
                this.querySelectorAll('[data-init-df]').forEach((el) => { el.removeAttribute('data-init-df') });
            }
        })
        new MasterTimeline({
            el: this,
            timeline: this.tl,
            tweenArr: [
                new RevealText({ el: this.querySelector('.plus-hero-title .txt'), color: 'black', isHighlight: true, allowMobile: true }),
                new FadeSplitText({ el: this.querySelector('.plus-hero-desc .txt'), delay: .6, allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-label'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-newprice-label'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-oldprice'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-newprice-save'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-details .div-line'), allowMobile: true }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-details-label'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-details-explore-label'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-details-explore-btn'), allowMobile: true  }),
                ...Array.from(this.querySelectorAll('.plus-hero-left-details-list-item')).flatMap((el, i) => 
                    new FadeIn({ el, delay: `<=${i * 0.1}`, allowMobile: true  })
                ),
                new FadeIn({ el: this.querySelector('.plus-hero-left-details-btn'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-details-note'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-product-line'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-product-label'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-product-inner'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-product-img'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-product-content-title'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-product-content-link'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-guarantee .div-line'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-guarantee-icon'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-guarantee-content-label'), allowMobile: true  }),
                new FadeIn({ el: this.querySelector('.plus-hero-left-guarantee-content-sub'), allowMobile: true  }),

            ]
        });
    }
    initPLusOffer() {
        this.threeInit();
    }
    threeInit() {
        const scene = new THREE.Scene();
        const el = this.querySelector('.plus-hero-right-product-canvas');

        const yPositionMap = {
            mb: 0,
            tb: 0,
            dsk: -0.2
        }[getScreenType().type];

        const camera = new THREE.PerspectiveCamera(30, el.clientWidth / el.clientHeight, 0.1, 1000);
        const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(el.clientWidth, el.clientHeight);
        renderer.domElement.style.position = 'absolute';
        renderer.domElement.style.top = '0';
        renderer.encoding = THREE.sRGBEncoding;
        renderer.physicallyCorrectLights = true;
        el.appendChild(renderer.domElement);

        const loader = new GLTFLoader();
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
        loader.setDRACOLoader(dracoLoader);

        let obj;
        const path = this.getAttribute('data-glb');
        loader.load(path, (gltf) => {
            gltf.scene.traverse((child) => {
                obj = gltf.scene;
                let toRemove = [];
                obj.children[0].children.map((child) => {
                    if (child.name.includes('roti')) {
                        toRemove.push(child)
                    }
                })
                toRemove.map((child) => {
                    obj.children[0].remove(child);
                    child.geometry.dispose();
                    scene.remove(child)
                    child.remove();
                })
                if (child instanceof THREE.Mesh) {
                    child.castShadow = true;
                    switch (child.name) {
                        case 'attribdelete5':
                            child.material.roughness = .3
                            // child.material = new THREE.MeshStandardMaterial({ color: 0x000000, metalness: 0.8, roughness: 0.2 });
                            break;
                    }
                }
            });

            obj.scale.set(9.5, 9.5, 9.5);
            obj.position.set(0, yPositionMap, 0);
            scene.add(obj);
            let tlBg = gsap.timeline({
                scrollTrigger: {
                    trigger: this,
                    start: 'top top',
                    end: 'bottom top',
                    scrub: true,
                }
            });
            tlBg.to(obj.rotation, {y: Math.PI * -.5, ease: 'none'})

            new FadeIn({ el: this.querySelector('.plus-hero-right-product-canvas')})
        }, undefined, (error) => console.error(error));

        camera.position.set(0, 0, 11);
        camera.lookAt(0, 0, 0);

        const hdrLoader = new RGBELoader();
        const hdrPath = this.getAttribute('data-hdr');
        hdrLoader.load(hdrPath, (texture) => {
            texture.mapping = THREE.EquirectangularReflectionMapping;
            texture.encoding = THREE.sRGBEncoding;
            scene.environment = texture;
            scene.environmentIntensity = 1.0;
        });
        const animate = () => {
            requestAnimationFrame(animate);
            if (isInViewport(el)) {
                renderer.render(scene, camera);
            }
        };

        animate();
        function onWindowResize() {
            camera.aspect = el.clientWidth / el.clientHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(el.clientWidth, el.clientHeight);
        }
        window.addEventListener('resize', onWindowResize);
    }
    setupRichText() {
        const listContents = this.querySelectorAll('.plus-hero-left-details-list-item');
        listContents.forEach(content => {
            const links = content.querySelectorAll('a');
            if (links.length) {
                links.forEach(link => {
                    const line = document.createElement('div');
                    line.classList.add('not-anim');
                    line.classList.add('div-line');
                    link.classList.add('txt-link', 'hover-un');
                    link.appendChild(line);
                })
            }
        })
    }
}

customElements.define('plus-hero', PlusHero);